import { render, staticRenderFns } from "./RedesignCallInfo.vue?vue&type=template&id=0c326462"
import script from "./RedesignCallInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./RedesignCallInfo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./RedesignCallInfo.vue?vue&type=style&index=0&id=0c326462&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports